module.exports = __webpack_public_path__ + "static/Physiotherapy-eb1a67539f83372608152459f35972cf.jpg";